// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"WhatsAppFloatingButton_whatsappBtn__LqP7C","icon":"WhatsAppFloatingButton_icon__5yYC2"};